import { render, staticRenderFns } from "./ChristmasSelection.vue?vue&type=template&id=2eb46a6f&name=christmas-selection&"
import script from "./ChristmasSelection.vue?vue&type=script&lang=js&"
export * from "./ChristmasSelection.vue?vue&type=script&lang=js&"
import style0 from "./ChristmasSelection.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports